var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cog-square-payment" },
    [
      _c(
        "c-square-card",
        {
          ref: "card",
          attrs: {
            "application-id": _vm.apiKey,
            locale: _vm.$culture.name,
            "input-styles": _vm.inputStyles,
            "save-card": _vm.saveCard,
            "location-id": _vm.locationId,
            "location-currency-code": _vm.locationCurrencyCode,
            "payment-sdk-url": _vm.paymentSdkUrl,
            "suppress-buyer-verification": _vm.suppressBuyerVerification
          },
          on: {
            ready: function($event) {
              return _vm.$emit("ready")
            },
            cardEvent: _vm.handleCardEvent,
            "authentication-complete": _vm.authenticationComplete
          }
        },
        [
          _c(
            "div",
            {
              ref: "cardContainer",
              staticClass: "cog-square-card cog-payment__frame",
              attrs: { id: "card-container" }
            },
            [
              _c("div", {
                staticClass: "cog-input__placeholder",
                on: {
                  click: function($event) {
                    return _vm.$refs.card.initializeForm()
                  }
                }
              })
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }